import { useRef, useState } from 'react';

import { Popover, PopoverContent, PopoverTrigger } from '../../../atoms';
import {
  type SidebarNavigationItemProps,
  type SidebarSubNavigationItemProps,
} from '../types/Sidebar.types';

import { SidebarMenuButton, SidebarMenuItem } from './SidebarMenu';
import { SidebarSubItem } from './SidebarSubItem';

interface SidebarCollapsedSubMenuProps {
  subItem: SidebarNavigationItemProps & {
    subItems: SidebarSubNavigationItemProps[];
  };
}

export const SidebarCollapsedSubMenu = ({
  subItem,
}: SidebarCollapsedSubMenuProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const hoverTimeoutRef = useRef<NodeJS.Timeout>();

  const handleMouseEnter = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setIsHovered(false);
    }, 250);
  };

  if (subItem.isDisabled) {
    return (
      <SidebarMenuButton
        tooltip={subItem.title}
        isActive={subItem.isActive}
        isDisabled={subItem.isDisabled}
      >
        {subItem.icon && <subItem.icon />}
        <span>{subItem.title}</span>
      </SidebarMenuButton>
    );
  }

  return (
    <SidebarMenuItem>
      <Popover open={isHovered} onOpenChange={setIsHovered}>
        <PopoverTrigger asChild>
          <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <SidebarMenuButton
              isActive={subItem.isActive}
              isDisabled={subItem.isDisabled}
            >
              {subItem.icon && <subItem.icon />}
              <span>{subItem.title}</span>
            </SidebarMenuButton>
          </div>
        </PopoverTrigger>
        <PopoverContent
          side="right"
          align="start"
          className="p-2 dark"
          onOpenAutoFocus={(e) => e.preventDefault()}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className="space-y-1">
            {subItem?.subItems.map((subItem) => (
              <SidebarSubItem subItem={subItem} key={subItem.title} />
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </SidebarMenuItem>
  );
};
